/**
 * `FeatureIntro` starts expanded the first time. Working screens start collapsed (same approach
 * as the sequences, forms and flows intros): once per user we write the "collapsed" marker the
 * intro reads, plus a "seeded" marker so a later "expand" choice is remembered. Storage failures
 * are ignored (the intro then starts expanded).
 */
export function seedCollapsedOnce(userId: string, featureKey: string): void {
  try {
    const seeded = `wato.featureIntro.${userId}.${featureKey}.seeded`;
    if (window.localStorage.getItem(seeded) !== null) return;
    window.localStorage.setItem(seeded, "1");
    const key = `wato.featureIntro.${userId}.${featureKey}`;
    if (window.localStorage.getItem(key) === null) window.localStorage.setItem(key, "collapsed");
  } catch {
    /* storage unavailable */
  }
}
